<template>
  <el-table-column
    prop="type"
    label="Típus"
    min-width="150"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <el-tag
        v-if="scope.row.is_customer"
        type="success"
        size="small"
        style="margin-right: 5px;"
      >
        Vevő
      </el-tag>
      <el-tag
        v-if="scope.row.is_supplier"
        type="primary"
        size="small"
      >
        Beszállító
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'company.name',
};
</script>
